import { BaseUseCase } from "@domains/useCases/UseCaseBase";
export default class DownloadKYCDataUseCase extends BaseUseCase {
    constructor(kycRepo) {
        super();
        this.kycRepo = kycRepo;
    }
    async fetchResult(req) {
        return await this.kycRepo.downloadKYC(req);
    }
}
